import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
export const take = (source, amount) => {
    const amountLeft = amount > 0 ? amount : 0;
    const dataFunc = source.dataFunc;
    switch (dataFunc.type) {
        case 1:
            const generator1 = () => dataFunc.generator().splice(0, amountLeft);
            return new BasicParallelEnumerable({
                generator: generator1,
                type: 1,
            });
        case 2:
            const generator2 = () => dataFunc.generator().then((x) => x.splice(0, amountLeft));
            return new BasicParallelEnumerable({
                generator: generator2,
                type: 2,
            });
        case 0:
        default:
            const generator3 = () => dataFunc.generator().then((x) => x.splice(0, amountLeft));
            return new BasicParallelEnumerable({
                generator: generator3,
                type: 0,
            });
    }
};
